export const __wrapper = props => ({
	width: '100%',
	backgroundColor: props.theme.colorWhite,
	overflow: 'auto',
	height: props.fixed ? 48 : 'auto',
	position: props.abs ? 'absolute' : 'initial',
	...props.theme.regularBaseFont,
})

export const __innerWrapper = props => ({
	minHeight: 48,
	width: '100%',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-around',
	position: `${props.fixed ? 'fixed' : 'relative'}`,
	backgroundColor: props.theme.colorWhite,
	// boxShadow: props.noShadow ? 'none' : props.theme.boxShadow.thin,
	zIndex: props?.zIndex || props.theme.zIndex.level3,
	overflow: 'scroll',
	whiteSpace: 'nowrap',
	extend: [
		{
			condition: props.transparent,
			style: {
				backgroundColor: props.theme.colorTransparent,
				boxShadow: 'unset',
			},
		},
		{
			condition: props.leftPadding,
			style: {
				paddingLeft: 5,
			},
		},
	],
})

export const __searchWrapper = ({ theme, isError }) => ({
	display: 'flex',
	padding: 5,
	borderRadius: theme.primary(theme).borderRadius,
	alignItems: 'center',
	flex: 1,
	boxSizing: 'border-box',
	border: `1px solid ${theme.colors.lightGrey2}`,
	extend: [
		{
			condition: isError,
			style: {
				border: `1px solid ${theme.colors.errorRed}`,
			},
		},
	],
})

export const __errorText = ({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	color: theme.colors.errorRed,
	fontSize: theme.font.size14,
	fontWeight: theme.font.weight400,
	letterSpacing: 0.2,
})

export const __input = ({ theme }) => ({
	width: '100%',
	background: 'transparent',
	padding: 2,
	...theme.regularBaseFont,
	border: 'none',
	color: theme.colorGrayLight,
	borderRadius: theme.borderRadius,
	outline: 'none',
	onFocus: {
		outline: 'none',
		background: 'transparent',
	},
})

export const __searchIcon = () => ({
	width: 20,
	'> svg': {
		width: '100%',
		height: '100%',
	},
	display: 'flex',
	paddingRight: 5,
})

export const __cancelSearch = () => ({
	padding: 2,
	paddingLeft: 8,
	color: 'blue',
})

export const __cancelIcon = () => ({
	width: 12,
	display: 'flex',
	cursor: 'pointer',
	'> svg': {
		width: '100%',
		height: '100%',
	},
})
